import { apiMaskAsReadNotification, apiNotificationCount, apiNotificationRecentList } from "@/services/notification"
import { BellOutlined } from "@ant-design/icons"
import { ProList } from "@ant-design/pro-components"
import { useRequest } from "@umijs/max"
import { Badge, message, Popover } from "antd"

const NotificationComponent: React.FC = () => {

    const { data: count } = useRequest(apiNotificationCount);

    const Content = () => (
        <div>
            <div className="text-right p-2 text-xs border-b border-dashed">
                <div className="text-slate-400 cursor-pointer">Đánh dấu đã đọc</div>
            </div>
            <div className="w-80">
                <ProList
                    ghost
                    size="small"
                    request={apiNotificationRecentList}
                    metas={{
                        title: {
                            dataIndex: 'title',
                            render: (dom, entity: any) => <div onClick={async () => {
                                await apiMaskAsReadNotification(entity.id);
                                message.success('Đã đọc thông báo!');
                            }}>{dom} {!entity.isRead && <span className="text-red-500">&bull;</span>}</div>
                        },
                        description: {
                            dataIndex: 'description'
                        },
                        subTitle: {
                            dataIndex: 'createdDate',
                            valueType: 'fromNow'
                        }
                    }}
                />
            </div>
            <div className="p-1 text-center border-t border-dashed">
                <div className="text-slate-400 cursor-pointer">Xem tất cả</div>
            </div>
        </div>
    )

    return (
        <>
            <Popover content={<Content />} overlayInnerStyle={{
                padding: 0
            }}>
                <Badge count={count} size="small">
                    <button className="text-slate-500" type="button"><BellOutlined /></button>
                </Badge>
            </Popover>
        </>
    )
}

export default NotificationComponent